import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const PAGE_TYPES = [
]

export const PAGE_STATUSES = [
  'draft',
  'published',
]

const entityColumns = {
  id: {
    model_name: 'Page',
    column_type: 'id',
    label_key_path: 'page.id',
  },
  created_at: {
    model_name: 'Page',
    column_type: 'datetime',
    label_key_path: 'page.createdAt',
  },
  updated_at: {
    model_name: 'Page',
    column_type: 'datetime',
    label_key_path: 'page.updatedAt',
  },
  slug: {
    model_name: 'Page',
    column_type: 'string',
    label_key_path: 'page.slug',
  },
  title: {
    model_name: 'Page',
    column_type: 'string',
    label_key_path: 'page.title',
  },
  type: {
    model_name: 'Page',
    column_type: 'type',
    extra: {
      options: [],
    },
    label_key_path: 'page.type',
  },
  application: {
    model_name: 'Page',
    column_type: 'belongs_to',
    label_key_path: 'page.application',
    extra: {
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
      display_column: 'name',
    },
  },
  application_id: {
    model_name: 'Page',
    column_type: 'belongs_to',
    label_key_path: 'page.application',
    extra: {
      association_name: 'application',
      model_name: 'Application',
      foreign_key: 'application_id',
      display_column: 'name',
    },
  },
  status: {
    model_name: 'Page',
    column_type: 'enum',
    extra: {
      options: ['draft', 'published'],
    },
    label_key_path: 'page.status',
  },
  views_count: {
    model_name: 'Page',
    column_type: 'integer',
    label_key_path: 'page.viewsCount',
  },
  mini_program_path: {
    model_name: 'Page',
    column_type: 'string',
    label_key_path: 'page.miniProgramPath',
  },
  wxacode: {
    model_name: 'Page',
    column_type: 'attached',
    extra: {
      size: 20,
    },
    label_key_path: 'page.wxacode',
  },
  wxacode_with_audio: {
    model_name: 'Page',
    prop: 'wxacode_attachment',
    label_key_path: 'page.wxacodeAttachment',
    column_type: 'attached',
    extra: {
      accept: 'audio/mp3, audio/aac',
      type: 'audio',
      size: 20,
    },
  },
  content: {
    model_name: 'Page',
    column_type: 'text',
    label_key_path: 'page.content',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
